import { render, staticRenderFns } from "./CapitecPayBankForm.vue?vue&type=template&id=65eaa078&scoped=true"
import script from "./CapitecPayBankForm.vue?vue&type=script&lang=js"
export * from "./CapitecPayBankForm.vue?vue&type=script&lang=js"
import style0 from "./CapitecPayBankForm.vue?vue&type=style&index=0&id=65eaa078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eaa078",
  null
  
)

export default component.exports